import { render } from "./AiDesignChat.vue?vue&type=template&id=3be6269c&scoped=true"
import script from "./AiDesignChat.vue?vue&type=script&lang=js"
export * from "./AiDesignChat.vue?vue&type=script&lang=js"

import "./AiDesignChat.vue?vue&type=style&index=0&id=3be6269c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be6269c"]])

export default __exports__